import { ApiService } from './api';

export interface ImpersonationStatus {
  impersonating: boolean;
  admin?: {
    id: number;
    name: string;
    email: string;
  };
  user?: {
    id: number;
    name: string;
    email: string;
    role: string;
  };
  started_at?: string;
}

export interface ImpersonationStartResponse {
  success: boolean;
  target_user: {
    id: number;
    name: string;
    email: string;
    role: string;
  };
  dashboard_url: string;
  impersonation_started_at: string;
  impersonation_headers?: {
    'X-Impersonating-User-Id': number;
    'X-Admin-Id': number;
  };
}

export interface ImpersonationStopResponse {
  success: boolean;
  admin_id: number;
  admin: {
    id: number;
    name: string;
    email: string;
    role: string;
  } | null;
}

export class ImpersonationService {
  /**
   * Start impersonating a user
   */
  static async startImpersonation(userId: number): Promise<ImpersonationStartResponse> {
    const response = await ApiService.post<ImpersonationStartResponse>(
      `/admin/impersonate/${userId}`,
      {}
    );
    
    // Store impersonation headers in localStorage for API requests
    if (response.impersonation_headers) {
      localStorage.setItem('impersonating_user_id', response.impersonation_headers['X-Impersonating-User-Id'].toString());
      localStorage.setItem('impersonation_admin_id', response.impersonation_headers['X-Admin-Id'].toString());
    }
    
    return response;
  }
  
  /**
   * Stop impersonating
   */
  static async stopImpersonation(): Promise<ImpersonationStopResponse> {
    const response = await ApiService.post<ImpersonationStopResponse>(
      '/admin/impersonate/stop',
      {}
    );
    
    // Clear impersonation headers from localStorage
    localStorage.removeItem('impersonating_user_id');
    localStorage.removeItem('impersonation_admin_id');
    
    return response;
  }
  
  /**
   * Get impersonation status
   */
  static async getStatus(): Promise<ImpersonationStatus | null> {
    try {
      const response = await ApiService.get<{ 
        success: boolean; 
        data: ImpersonationStatus | null 
      }>('/admin/impersonate/status');
      return response.data;
    } catch (error) {
      console.error('Failed to get impersonation status:', error);
      return null;
    }
  }
  
  /**
   * Check if currently impersonating (from response headers)
   */
  static checkImpersonationHeaders(response: Response): boolean {
    return response.headers.get('X-Impersonation-Active') === 'true';
  }
}
